import { useEffect,useState } from 'react';
import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { Typography } from '@mui/material';
import '../../../../cssfiles/homepage.css';


export default function Cardtext(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const livedata = useSelector((state) => state.mainpagedata.livedata);
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    const [value1, setValue1] = useState(0)
    const [time1, setTime1] = useState("01-01-1970 00:00:00")
    const [value2, setValue2] = useState(0)
    const [time2, setTime2] = useState("01-01-1970 00:00:00")
    const [value3, setValue3] = useState(0)
    const [time3, setTime3] = useState("01-01-1970 00:00:00")
    const color_map = new Map();

    var tagproperties = props.widgetprop.props.extended.tagprops;
    var tagtext = [];
    var current_thd_data = [2.91, 1.91, 1.91];
    var voltage_thd_data = [1.91, 3.91, 1.93];
    var current_data = [1.91, 1.91, 1.91];
    var voltage_data = [1.91, 1.91, 1.91];
    const [data, setData] = useState(voltage_thd_data);
    tagproperties.map((datatag)=>{
        tagtext.push(datatag.tagname)

    })

    var chartfontfamily=props.widgetprop.props.extended.fontfamily;
    var chartfontweight=props.widgetprop.props.extended.fontweight;
  
    useEffect(() => {
        if(livedata.length) {
            for(let i=0; i<livedata.length; i++) {
                //console.log("value card ",livedata[i].TagId, props.widgetprop.props.extended.tagprops[0].tagid)
                if(parseInt(props.widgetprop.props.extended.tagprops[0].tagid) === parseInt(livedata[i].TagId)) {
                    //console.log("livedata[i].value ",livedata[i].value)
                    setValue1(livedata[i].value.toFixed(2))
                    var date = new Date(livedata[i].timestamp * 1000)
                    var month = date.getMonth()+1;
                    var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                    setTime1(timestamp)
                }

                if(parseInt(props.widgetprop.props.extended.tagprops[1].tagid) === parseInt(livedata[i].TagId)) {
                    //console.log("livedata[i].value ",livedata[i].value)
                    setValue2(livedata[i].value.toFixed(2))
                    var date = new Date(livedata[i].timestamp * 1000)
                    var month = date.getMonth()+1;
                    var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                    setTime2(timestamp)
                }

                if(parseInt(props.widgetprop.props.extended.tagprops[2].tagid) === parseInt(livedata[i].TagId)) {
                    //console.log("livedata[i].value ",livedata[i].value)
                    setValue3(livedata[i].value.toFixed(2))
                    var date = new Date(livedata[i].timestamp * 1000)
                    var month = date.getMonth()+1;
                    var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                    setTime3(timestamp)
                }
            }
        }
    },[livedata])

    useEffect(()=>{
        switch(props.widgetprop.widgetname){
            case 'THD Current (%)':
                setData(current_thd_data)
                break
            case 'THD Voltage (%)':
                setData(voltage_thd_data)
                break
            case 'Current (A)':
                setData(current_data)
                break
            case 'Voltage (V)':
                setData(voltage_data)
                break

        }
    },[props.widgetprop.widgetname,sdate_edate_selected])

    //{console.log("props.widgetprop.props.extended  Cardtext",props.widgetprop.props.extended)}
    {/*<div style={{height:"10px", width:"10px", backgroundColor:"#DC272D", marginTop:"7px", borderRadius:8}}></div>*/}
    return(
        <>
                     
            {
                /*
                tagproperties.map((datatag,index)=>{
                    <div style={{display:"flex", flexDirection:"row", padding:20}}>
                        
                        <Typography sx={{fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:props.widgetprop.props.extended.fontweight, color:props.widgetprop.props.extended.color}}>{data[index]}</Typography>
                    </div>
                })
                */
            }
            <div style={{display:"flex", flexDirection:"column", gap:"50px",margin:"25px"}}>
                <div style={{display:"flex", flexDirection:"row", justifyContent:'flex-start',alignItems: 'center' }}>
                    <Typography sx={{fontSize:"16px",fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:400, color:'var(--PrimaryText)'}}>{tagtext[0]}</Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Typography sx={{fontSize:"23px",fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:800, color:"#DC272D"}}>{value1}</Typography>
                </div>
                <div style={{display:"flex", flexDirection:"row",justifyContent:"flex-start",alignItems: 'center'}}>
                    <Typography sx={{fontSize:"16px",fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:400, color:'var(--PrimaryText)'}}>{tagtext[1]}</Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Typography sx={{fontSize:"23px",fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:800, color:"#EE8C19"}}>{value2}</Typography>
                </div>
                <div style={{display:"flex", flexDirection:"row",justifyContent:"flex-start",alignItems: 'center',}}>
                    <Typography sx={{fontSize:"16px",fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:400, color:'var(--PrimaryText)'}}>{tagtext[2]}</Typography>
                    <div style={{flexGrow: 1}}></div>
                    <Typography sx={{fontSize:"23px",fontFamily: props.widgetprop.props.extended.fontfamily, fontWeight:800, color:"#6A6A6A"}}>{value3}</Typography>
                </div>
                
            </div>
            <div style={{display: 'flex', alignItems:'center', justifyContent: 'center'}}>
                    <Typography style={{fontFamily:"Roboto", fontSize:"18px",fontWeight:400, color: 'var(--PrimaryText)'}}> {time1} </Typography>
            </div>
        </> 
    )
}